<template>
    <div class="clearfix">
        <a-upload :list-type="type === 'image' ? 'picture-card' : 'picture'" :file-list="fileList"
            :before-upload="beforeUpload" :customRequest="customRequest" @preview="handlePreview"
            @change="handleChange">
            <div v-if="fileList.length < limit">
                <a-icon type="plus" />
                <div class="ant-upload-text">
                    上传
                </div>
            </div>
        </a-upload>
        <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
            <img alt="TCrater" style="width: 100%" :src="previewImage" />
        </a-modal>
    </div>
</template>
<script>
import { successNotification, errorNotification } from '../utils/util';
import { uploadFile } from '../utils/user';

function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
    })
}
function getToken() {
    const token = window.sessionStorage.getItem("token");
    return token || "";
}
export default {
    name: 'FileUpload',
    props: {
        // 默认值
        value: [String, Object, Array],
        // 文件类型
        type: {
            type: String,
            default: 'image'
        },
        // 大小限制(MB)
        fileSize: {
            type: Number,
            default: 5
        },
        // 个数限制
        limit: {
            type: Number,
            default: 5
        },
        // 文件类型, 例如['png', 'jpg', 'jpeg']
        fileType: {
            type: Array,
            default: () => ['png', 'jpg', 'jpeg']
        }
    },
    components: {
    },
    data() {
        return {
            previewVisible: false,
            previewImage: '',
            fileList: []
        }
    },

    watch: {
        value: {
            handler(val) {
                if (val) {
                    let temp = 1
                    // 首先将值转为数组
                    const list = Array.isArray(val) ? val : this.value.split(',')
                    // 然后将数组转为对象数组
                    this.fileList = list.map(item => {
                        if (typeof item === 'string') {
                            item = { name: item, url: item, status: 'done' }
                        }
                        item.uid = item.uid || new Date().getTime() + temp++
                        return item
                    })
                } else {
                    this.fileList = []
                    return []
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        beforeUpload(file) {
            // 校检文件类型
            if (this.fileType) {
                let fileExtension = ''
                if (file.name.lastIndexOf('.') > -1) {
                    fileExtension = file.name.slice(file.name.lastIndexOf('.') + 1)
                }
                const isTypeOk = this.fileType.some((type) => {
                    if (file.type.indexOf(type) > -1) return true
                    if (fileExtension && fileExtension.indexOf(type) > -1) return true
                    return false
                })
                if (!isTypeOk) {
                    this.$message.error(`文件格式不正确, 请上传${this.fileType.join('/')}格式文件!`)
                    return false
                }
            }
            // 校检文件大小
            if (this.fileSize) {
                const isLt = file.size / 1024 / 1024 < this.fileSize
                if (!isLt) {
                    this.$message.error(`上传文件大小不能超过 ${this.fileSize} MB!`)
                    return false
                }
            }
            return true
        },
        handleCancel() {
            this.previewVisible = false
        },
        async handlePreview(file) {
            if (!file.url && !file.preview) {
                file.preview = await getBase64(file.originFileObj)
            }
            this.previewImage = file.url || file.preview
            this.previewVisible = true
        },
        // 自定义上传，可以自定义上传接口，不用通过action属性，还是非常灵活的
        customRequest(file) {
            // file 是上传的文件
            // 后端需要接受的参数是 formData数据，
            const formData = new FormData()
            formData.append('file', file.file)

            uploadFile(formData).then(res => {
                if (res.code === 0) {
                    successNotification('上传成功')
                    let fileItem = { name: res.name, uid: new Date().getTime() + 121, url: res.url, status: 'done' }
                    this.fileList.push(fileItem)
                    let toString = this.listToString(this.fileList)
                    this.$emit('input', toString)
                } else {
                    errorNotification('上传失败')
                }
            })
                .catch(err => {
                    console.info("err:", err)
                })
        },

        // 对象转成指定','字符串分隔
        listToString(list, separator) {
            console.log(list)
            let strs = ''
            separator = separator || ','
            for (let i in list) {
                let url = list[i].url
                strs += url + separator
            }
            return strs !== '' ? strs.substr(0, strs.length - 1) : ''
        },
        async handleChange(info) {
            if (info.file.status === 'removed') {
                successNotification('删除成功')
                this.fileList = info.fileList
                let toString = this.listToString(this.fileList)
                this.$emit('input', toString)
            }
        }
    }
}
</script>

<style>
/* you can make up upload button and sample style by using stylesheets */
.ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
}
</style>